import React, {useEffect} from 'react';
import SalesTransactionsAPI from "../../api/salesTransactions";
import {formatAccount} from "../../features/ValueFormater";
import OverviewAccountSkeleton from "../skeletons/TableSkeleton";

function CurrentBalance({availableBalances, balancesLoading}) {

    return (
        <>
            {
                balancesLoading? (
                    <OverviewAccountSkeleton />
                ) : (
                    <div className="row">
                        <Item availableBalances={availableBalances[0]}/>
                        <Item availableBalances={availableBalances[1]} />
                    </div>
                )
            }
        </>

    );
}

const Item = ({availableBalances}) => (
    <div className="col-lg-6 col-md-12 curencySeles">
        <div className="items">
            <div className="title">AVAILABLE BALANCE ({availableBalances?.CurrencyID === 1? "USD" : "LBP"})</div>
            <div className="amount">{formatAccount(availableBalances?.AvailableBalance || 0, availableBalances?.CurrencyID)}</div>

            <div className="row">
                <div className="col-3">
                    <div
                        className="subamout">{formatAccount(availableBalances?.AvailableSales || 0, availableBalances?.CurrencyID)}</div>
                    <div className="subtitle">Available Sales</div>
                </div>
                <div className="col">
                    <div
                        className="subamout">{formatAccount(availableBalances?.Reversal || 0, availableBalances?.CurrencyID)}</div>
                    <div className="subtitle">Reversal</div>
                </div>
            </div>
        </div>
    </div>
)

export default CurrentBalance;